import { Route, Routes } from 'react-router-dom';
import './App.css';
import SignUp from './Pages/SignUp/SignUp';


function App() {
  return (
    <div className="App">
<Routes>
  <Route path='/' element={<SignUp/>}/>
</Routes>
    </div>
  );
}

export default App;
